// extracted by mini-css-extract-plugin
export default {"to":"SearchExamReviewList_to__yJrb2"};